define(()=> {
    return ['$filter', ($filter)=> {
        return {
            formatShortDate: (date)=> {
                return $filter('date')(new Date(date), 'shortDate');
            }
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/l10n/DateFormatter.js
 **/